import { render, staticRenderFns } from "./GlobalFilter.vue?vue&type=template&id=2fd2ddf3&scoped=true&lang=html&"
import script from "./GlobalFilter.vue?vue&type=script&lang=js&"
export * from "./GlobalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2ddf3",
  null
  
)

export default component.exports